import { Badge, Field, Stack, useRecipe } from '@chakra-ui/react';

const LABEL_COLUMN_WIDTH = 'var(--field-label-width, 80px)';
const COLUMN_GAP = '0.375rem';
const CONTROL_COLUMN_OFFSET = `calc(${LABEL_COLUMN_WIDTH} + ${COLUMN_GAP})`;

const toTokenReference = (tokenPath) => `{${tokenPath}}`;

const useControlHeight = (size) => {
  const inputRecipe = useRecipe({ key: 'input' });

  if (size === undefined) {
    return undefined;
  }

  return toTokenReference(inputRecipe.config.variants.size[size]['--input-height']);
};

const VFormFieldHorizontal = ({
  label,
  errorText,
  helperText,
  children,
  optional = false,
  size = undefined,
  ...props
}) => {
  const controlHeight = useControlHeight(size);

  return (
    <Field.Root
      alignItems="flex-start"
      orientation="horizontal"
      flexWrap="wrap"
      gap={COLUMN_GAP}
      {...props}
    >
      {label && (
        <Field.Label fontWeight="semibold" minWidth="0" minHeight={controlHeight}>
          {label}
          {optional && (
            <Field.RequiredIndicator
              fallback={
                <Badge size="xs" variant="surface">
                  Optional
                </Badge>
              }
            />
          )}
        </Field.Label>
      )}
      <Stack gap="1.5" flex="1" minWidth="0" minHeight={controlHeight} justifyContent="center">
        {children}
      </Stack>
      {(errorText || helperText) && (
        <Stack
          gap={COLUMN_GAP}
          width="full"
          paddingInlineStart={label ? CONTROL_COLUMN_OFFSET : undefined}
        >
          {errorText && <Field.ErrorText>{errorText}</Field.ErrorText>}
          {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
        </Stack>
      )}
    </Field.Root>
  );
};

export default VFormFieldHorizontal;
